module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "dropdown",
    staticClass: "dropdown",
    class: {
      'open': _vm.open
    },
    attrs: {
      "title": _vm.title || 'Click to select a value'
    },
    on: {
      "keydown": _vm.handleKeydown
    }
  }, [_c('button', {
    ref: "toggle",
    staticClass: "toggle",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_vm._v("\n    " + _vm._s(_vm.selectedLabel) + " ▾\n  ")]), _vm._v(" "), (_vm.open) ? _c('div', {
    staticClass: "options",
    style: (_vm.optionsStyle)
  }, [(_vm.showFilter !== false) ? _c('div', {
    staticClass: "filter-section",
    on: {
      "click": _vm.focusFilter
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterValue),
      expression: "filterValue"
    }],
    ref: "filter",
    staticClass: "filter",
    domProps: {
      "value": (_vm.filterValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterValue = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filtered-options",
    style: (_vm.filteredOptionsStyle)
  }, _vm._l((_vm.filteredOptions), function(option) {
    return _c('button', {
      ref: 'option-' + option.value,
      refInFor: true,
      staticClass: "option",
      class: {
        'selected': option.value === _vm.selectedValue
      },
      attrs: {
        "value": option.value
      },
      on: {
        "click": function($event) {
          _vm.handleChange(option.value)
        }
      }
    }, [_vm._v("\n        " + _vm._s(option.text) + "\n    ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "footer",
    style: (_vm.footerStyle)
  }, [_c('button', {
    staticClass: "modal-button",
    on: {
      "click": _vm.closeDropdown
    }
  }, [_vm._v("\n        Cancel\n      ")])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-131ff11b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropDown.vue
// module id = 322
// module chunks = 0